@if ({ showObsolete: showObsolete$ | async }; as content) {
  <div class="container-toggle-obsolete">
    <simple-toggle
      [checked]="content?.showObsolete === true"
      label="productView.showObsolete"
      [invertLabel]="true"
      [spaceBetween]="true"
      (callbackOnChange)="toggleObsolete($event)"
    ></simple-toggle>
  </div>
}
